import { Select } from '@consta/uikit/Select'
import type { Nullable, SelectItemKeyed } from 'common/types'
import type { FC } from 'react'

import {
  initialApproximations,
  interpolationItems,
  smoothingCore,
  typeOfCalculation,
} from '../constants'
import css from '../MapBuildingRightMenu.css'
import type {
  InterpolationItemsType,
  SequentialConvergenceAlgorithmMenuProps,
  TypeOfCalculationType,
} from '../types'

export const SequentialConvergenceAlgorithmMenu: FC<SequentialConvergenceAlgorithmMenuProps> = ({
  formData,
  updateSequentialConvergenceData,
}) => {
  const onInterpolationChange = (value: Nullable<InterpolationItemsType>) => {
    if (value) {
      updateSequentialConvergenceData(prev => {
        if (prev) {
          return { ...prev, isBilinear: !!(value.key === 'Bilinear') }
        }
      })
    }
  }

  const onSmoothingCoreChange = (value: Nullable<SelectItemKeyed>) => {
    if (value) {
      updateSequentialConvergenceData(prev => {
        if (prev) {
          return { ...prev, kernelSize3X3: !!(value.key === '3x3') }
        }
      })
    }
  }

  const onInitialApproximationsChange = (value: Nullable<SelectItemKeyed>) => {
    if (value) {
      updateSequentialConvergenceData(prev => {
        if (prev) {
          return { ...prev, initNxNy: +value.key }
        }
      })
    }
  }

  const onTypeOfCalculationChange = (value: Nullable<TypeOfCalculationType>) => {
    if (value) {
      updateSequentialConvergenceData(prev => {
        if (prev) {
          return { ...prev, calculation: value.key }
        }
      })
    }
  }

  return (
    <>
      <Select
        label="Интерполяция"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={interpolationItems}
        value={
          formData.sequentialConvergence?.isBilinear ? interpolationItems[0] : interpolationItems[1]
        }
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onInterpolationChange}
      />
      <Select
        label="Ядро сглаживания"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={smoothingCore}
        value={formData.sequentialConvergence?.kernelSize3X3 ? smoothingCore[0] : smoothingCore[1]}
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onSmoothingCoreChange}
      />
      <Select
        label="Число начальных приближений"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={initialApproximations}
        value={
          initialApproximations.filter(
            item => item.key === String(formData.sequentialConvergence?.initNxNy),
          )[0]
        }
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onInitialApproximationsChange}
      />
      <Select
        label="Вид расчёта"
        className={css.algorithmMenuTextFields}
        size="xs"
        items={typeOfCalculation}
        value={typeOfCalculation.find(
          item => item.key === formData.sequentialConvergence?.calculation,
        )}
        getItemKey={item => item.key}
        getItemLabel={item => item.label}
        onChange={onTypeOfCalculationChange}
      />
    </>
  )
}
